/**
 * @fileoverview gRPC-Web generated client stub for tprmquestionnaire
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: tprmquestionnaire/tprmquestionnaire.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.tprmquestionnaire = require('./tprmquestionnaire_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.tprmquestionnaire.QuestionnaireServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest,
 *   !proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse>}
 */
const methodDescriptor_QuestionnaireService_ListQuestionnaireTemplates = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListQuestionnaireTemplates',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest,
  proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listQuestionnaireTemplates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListQuestionnaireTemplates',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListQuestionnaireTemplates,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListQuestionnaireTemplatesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListQuestionnaireTemplatesResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listQuestionnaireTemplates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListQuestionnaireTemplates',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListQuestionnaireTemplates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetQuestionnaireFormRequest,
 *   !proto.tprmquestionnaire.QuestionnaireForm>}
 */
const methodDescriptor_QuestionnaireService_GetQuestionnaireForm = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/GetQuestionnaireForm',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetQuestionnaireFormRequest,
  proto.tprmquestionnaire.QuestionnaireForm,
  /**
   * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.QuestionnaireForm.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.QuestionnaireForm)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.QuestionnaireForm>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.getQuestionnaireForm =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetQuestionnaireForm',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetQuestionnaireForm,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetQuestionnaireFormRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.QuestionnaireForm>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.getQuestionnaireForm =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetQuestionnaireForm',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetQuestionnaireForm);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ExportFormCsvRequest,
 *   !proto.tprmquestionnaire.ExportFormCsvResponse>}
 */
const methodDescriptor_QuestionnaireService_ExportFormCsv = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ExportFormCsv',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ExportFormCsvRequest,
  proto.tprmquestionnaire.ExportFormCsvResponse,
  /**
   * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ExportFormCsvResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ExportFormCsvResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ExportFormCsvResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.exportFormCsv =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ExportFormCsv',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ExportFormCsv,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ExportFormCsvRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ExportFormCsvResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.exportFormCsv =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ExportFormCsv',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ExportFormCsv);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ImportFormCsvRequest,
 *   !proto.tprmquestionnaire.ImportFormCsvResponse>}
 */
const methodDescriptor_QuestionnaireService_ImportFormCsv = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ImportFormCsv',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ImportFormCsvRequest,
  proto.tprmquestionnaire.ImportFormCsvResponse,
  /**
   * @param {!proto.tprmquestionnaire.ImportFormCsvRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ImportFormCsvResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ImportFormCsvRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ImportFormCsvResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ImportFormCsvResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.importFormCsv =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ImportFormCsv',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ImportFormCsv,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ImportFormCsvRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ImportFormCsvResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.importFormCsv =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ImportFormCsv',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ImportFormCsv);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.SendQuestionnaireRequest,
 *   !proto.tprmquestionnaire.SendQuestionnaireResponse>}
 */
const methodDescriptor_QuestionnaireService_SendQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/SendQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.SendQuestionnaireRequest,
  proto.tprmquestionnaire.SendQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.SendQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.SendQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.SendQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.SendQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.SendQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.sendQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/SendQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_SendQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.SendQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.SendQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.sendQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/SendQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_SendQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListSentQuestionnairesRequest,
 *   !proto.tprmquestionnaire.ListSentQuestionnairesResponse>}
 */
const methodDescriptor_QuestionnaireService_ListSentQuestionnaires = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListSentQuestionnaires',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListSentQuestionnairesRequest,
  proto.tprmquestionnaire.ListSentQuestionnairesResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListSentQuestionnairesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListSentQuestionnairesResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListSentQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListSentQuestionnairesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListSentQuestionnairesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listSentQuestionnaires =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListSentQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListSentQuestionnaires,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListSentQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListSentQuestionnairesResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listSentQuestionnaires =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListSentQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListSentQuestionnaires);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListReceivedQuestionnairesRequest,
 *   !proto.tprmquestionnaire.ListReceivedQuestionnairesResponse>}
 */
const methodDescriptor_QuestionnaireService_ListReceivedQuestionnaires = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListReceivedQuestionnaires',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListReceivedQuestionnairesRequest,
  proto.tprmquestionnaire.ListReceivedQuestionnairesResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListReceivedQuestionnairesResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListReceivedQuestionnairesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listReceivedQuestionnaires =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListReceivedQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListReceivedQuestionnaires,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListReceivedQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListReceivedQuestionnairesResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listReceivedQuestionnaires =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListReceivedQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListReceivedQuestionnaires);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest,
 *   !proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse>}
 */
const methodDescriptor_QuestionnaireService_GetLatestQuestionnaireVersion = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/GetLatestQuestionnaireVersion',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest,
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse,
  /**
   * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.getLatestQuestionnaireVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetLatestQuestionnaireVersion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetLatestQuestionnaireVersion,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetLatestQuestionnaireVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.GetLatestQuestionnaireVersionResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.getLatestQuestionnaireVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/GetLatestQuestionnaireVersion',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_GetLatestQuestionnaireVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.CreateCommentRequest,
 *   !proto.tprmquestionnaire.Comment>}
 */
const methodDescriptor_QuestionnaireService_CreateComment = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/CreateComment',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.CreateCommentRequest,
  proto.tprmquestionnaire.Comment,
  /**
   * @param {!proto.tprmquestionnaire.CreateCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.Comment.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.CreateCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.Comment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.Comment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.createComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/CreateComment',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_CreateComment,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.CreateCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.Comment>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.createComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/CreateComment',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_CreateComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListCommentThreadRequest,
 *   !proto.tprmquestionnaire.ListCommentThreadResponse>}
 */
const methodDescriptor_QuestionnaireService_ListCommentThread = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.QuestionnaireService/ListCommentThread',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListCommentThreadRequest,
  proto.tprmquestionnaire.ListCommentThreadResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListCommentThreadResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListCommentThreadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListCommentThreadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.QuestionnaireServiceClient.prototype.listCommentThread =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListCommentThread',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListCommentThread,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListCommentThreadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListCommentThreadResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.QuestionnaireServicePromiseClient.prototype.listCommentThread =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.QuestionnaireService/ListCommentThread',
      request,
      metadata || {},
      methodDescriptor_QuestionnaireService_ListCommentThread);
};


module.exports = proto.tprmquestionnaire;

